"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_COLOR = void 0;
var DEFAULT_COLOR = '#425b76';
exports.DEFAULT_COLOR = DEFAULT_COLOR;